import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError, timeout, TimeoutError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoggerService } from '../services/logger/logger.service';
import { inject } from '@angular/core';
import { LogsType } from '../../shared/constants/logs-type.enum';
import { MessageService } from '../services/message/message.service';
import { MessageType } from '../../shared/constants/message-type.enum';

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const className = 'timeoutInterceptor';
  const logger = inject(LoggerService);
  const messageService = inject(MessageService);
  const requestTimeout = 600000;//environment.DV_HTTP_TIMEOUT || 3000;

  return next(req).pipe(
    timeout(requestTimeout),
    catchError((error: HttpErrorResponse | TimeoutError) => {
      if (error instanceof TimeoutError) {
        logger.logMessage(LogsType.ERROR, className, '', `URL: ${req.url} Tempo:${requestTimeout}ms`);
        messageService.showMessages('TIMEOUT', MessageType.ERROR);
        return throwError(() => error);
      }
      return throwError(() => error);
    })
  );
};
